import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useEffectOnce } from 'react-use';
import { useDispatch } from 'react-redux';
import { AddAccountButtonsGroup } from '../../../Profile/Accounts/components/AddAccountPreSelection/components/AddAccountButtonsGroup';
import { usePlaidLink } from '../../../_hooks/plaid/usePlaidLink';
import Back from '../../Navigation/Back/BackContainer';
import { BACKEND_KEY } from '../FinancialAccountsWorkflowConstants';
import { QuovoDisabledMessageModal } from '../../../Quovo/components/QuovoDisabledMessage/QuovoDisabledMessageModal';
import { setIsPlaidInfoMessageVisibility } from '../../../Plaid/state/actions';

const EmptyStateView = ({
  canGoBack,
  hasPlaid,
  onManualAddAccountPressed,
  workflowId,
  hasAccessToLinkAccounts,
  clientId,
  onFinishPlaidWorkflow,
}) => {
  const dispatch = useDispatch();

  useEffectOnce(() => {
    if (!hasAccessToLinkAccounts || !hasPlaid) {
      onManualAddAccountPressed(workflowId)();
    }
  });

  const [showQuovoMessage, setShowQuovoMessage] = useState(false);

  const { open: openPlaid, isLoading } = usePlaidLink({
    clientId,
    onSuccess: () => {
      dispatch(setIsPlaidInfoMessageVisibility(true));

      onFinishPlaidWorkflow(clientId, workflowId);
    },
    onExit: () => {
      onFinishPlaidWorkflow(clientId, workflowId);
    },
  });

  return (
    <div id="FinancialAccountsWorkflowEmptyState">
      {canGoBack && (
        <Back
          backText="Back"
          workflowId={workflowId}
          validationId={`${BACKEND_KEY}.AccountsLinkingSteps`}
        />
      )}
      <img
        className="adv-financial-accounts-lock"
        src={`${window.ADV.settings.endpoints.imgDir}multi_workflows/lock.png`}
        alt="Lock Icon"
      />
      <div className="adv-financial-accounts-workflow-title">
        Let&#39;s connect with your external accounts
      </div>
      <div className="adv-financial-accounts-checklist">
        <div className="adv-financial-accounts-checklist-item">
          Track your investment returns and asset allocation
        </div>
        <div className="adv-financial-accounts-checklist-item">
          Understand your monthly spending{' '}
        </div>

        <div className="adv-financial-accounts-checklist-item">
          Secure data with bank-level 256-bit {hasPlaid ? 'TLS' : 'SSL'} encryption
        </div>
      </div>

      <div className="adv-workflow-navigation-empty-financial-accounts">
        {hasPlaid ? (
          <AddAccountButtonsGroup
            isLoading={isLoading}
            plaidOnClick={() => openPlaid()}
            manualOnClick={onManualAddAccountPressed(workflowId)}
          />
        ) : (
          <div className="adv-workflow-navigation-next">
            <button
              type="button"
              className="adv-workflow-navigation-next-save-button"
              onClick={() => {
                setShowQuovoMessage(true);
              }}
            >
              Link an account
            </button>
            <div className="adv-financial-accounts-manual-text">
              Or add a&nbsp;
              <button
                onClick={onManualAddAccountPressed(workflowId)}
                type="button"
                className="adv-financial-accounts-manual-button"
              >
                manual account.
              </button>
            </div>
          </div>
        )}
      </div>
      {showQuovoMessage && (
        <QuovoDisabledMessageModal onRequestClose={() => setShowQuovoMessage(false)} />
      )}
    </div>
  );
};

EmptyStateView.propTypes = {
  canGoBack: PropTypes.bool.isRequired,
  hasAccessToLinkAccounts: PropTypes.bool.isRequired,
  hasPlaid: PropTypes.bool.isRequired,
  onManualAddAccountPressed: PropTypes.func.isRequired,
  workflowId: PropTypes.string.isRequired,
  clientId: PropTypes.string.isRequired,
  onFinishPlaidWorkflow: PropTypes.func.isRequired,
};

export default EmptyStateView;
